<template>
  <div class="detail-box">
    <div class="detailShade"></div>
    <div class="pop-box">
      <!-- 头部 -->
      <div class="header-box">
        <div class="header-Top">
          <img :src="Detail.orderInfo.appImage" alt="" />
          <div class="header-Top-right">
            <div class="appName">
              {{ Detail.orderInfo.appName || "嗨如意" }}
            </div>

            <div class="appCreateTime">
              创建时间：
              {{ Detail.orderInfo.appCreateTime || "2020-11-20 12:20" }}
            </div>
          </div>
        </div>
        <div class="header-Bottom">
          <div class="Bottom-item">
            应用终端：{{ Detail.orderInfo.platform }}
          </div>
          <div class="Bottom-item">功能模块：{{ Detail.orderInfo.title }}</div>
          <div class="Bottom-item">
            功能插件：{{ Detail.orderInfo.modList }}
          </div>
        </div>
      </div>
      <!-- 内容 -->
      <div class="detContent">
        <div class="cont-title">订单信息</div>
        <div class="cont-box">
          <div class="cont-item">
            订单编号
            <span style="float: right">{{ Detail.oid }}</span>
          </div>
          <div class="cont-item">
            订单状态
            <span style="float: right">{{ Detail.stateText }}</span>
          </div>
          <div class="cont-item">
            付款时间
            <span style="float: right">{{ Detail.orderInfo.payTime }}</span>
          </div>
          <div class="cont-item">
            支付方式
            <span style="float: right">{{ Detail.orderInfo.payMod }}</span>
          </div>
          <div class="cont-item" v-if="Detail.coupon">
            优惠码
            <span style="float: right">{{ Detail.coupon }}</span>
          </div>
          <div class="cont-item">
            订单金额
            <span style="float: right">{{ Detail.orderInfo.price }}</span>
          </div>
        </div>
      </div>

      <!-- 应付金额 -->
      <div class="detMoney">
        应付金额
        <div style="float: right; text-align: right">
          <div style="color: #1890ff; font-size: 20px">
            ¥ {{ Detail.orderInfo.price }}
          </div>
          <div v-if="Detail.price_discount">
            优惠 ¥ {{ Detail.price_discount }}
          </div>
        </div>
      </div>

      <!-- 关闭窗口 -->
      <div class="detButtom">
        <div class="guanbi" @click="guanbi">关闭窗口</div>

        <div class="fukuan" @click="fukuan">立即付款</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Detail: {
      type: Object,
    },
  },
  mounted: function () {
    console.log(JSON.parse(JSON.stringify(this.Detail)));
  },
  methods: {
    guanbi: function () {
      this.$emit("guanbiPop", true);
    },

    fukuan: function () {
      let openURL = `/api/redirect/order/${this.Detail.orderInfo.oid}`;
      this.$emit("guanbiPop", true);
      window.open(openURL);
    },
  },
};
</script>


<style lang="scss" scoped>
.detail-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 999;
}
.detailShade {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
}

.pop-box {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto auto;
  background: #fff;
  width: 460px;
  height: 594px;
  background: #ffffff;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
  opacity: 1;
  border-radius: 22px;
  padding: 0 20px;
  box-sizing: border-box;

  .header-box {
    height: 207px;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    padding: 20px 0;
    box-sizing: border-box;
    .header-Top {
      height: 74px;
      width: 100%;
      overflow: hidden;
      img {
        width: 74px;
        height: 74px;
        vertical-align: middle;
        margin-right: 20px;
        display: inline-block;
      }
      .header-Top-right {
        display: inline-block;
        height: 100%;
        width: calc(100% - 94px);
        vertical-align: middle;
        .appName {
          color: #333333;
          font-size: 16px;
          line-height: 16px;
          margin-top: 15px;
        }
        .appCreateTime {
          color: #a0aec0;
          font-size: 14px;
          line-height: 14px;
          margin-top: 5px;
        }
      }
    }
    .header-Bottom {
      height: calc(100% - 74px);
      width: 100%;
      line-height: 35px;
      .Bottom-item {
        width: 100%;
        color: #718096;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .detContent {
    height: 223px;
    width: 100%;
    padding: 20px 0;
    border-bottom: 1px solid #f5f5f5;
    .cont-title {
      color: #333333;
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
    }
    .cont-box {
      line-height: 35px;
      color: #718096;
      font-size: 14px;
    }
  }

  .detMoney {
    height: 89px;
    box-sizing: border-box;
    padding: 20px 0;
    border-bottom: 1px solid #f5f5f5;
    line-height: 27px;
    color: #718096;
    font-size: 14px;
  }

  .detButtom {
    height: 75px;
    line-height: 75px;
    text-align: right;

    .fukuan {
      width: 72px;
      height: 35px;
      background: #1890ff;
      opacity: 1;
      border-radius: 7px;
      display: inline-block;
      line-height: 35px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      box-sizing: border-box;
      cursor: pointer;
      margin-left: 10px;
    }

    .guanbi {
      width: 72px;
      height: 35px;
      border: 1px solid #edf2f7;
      opacity: 1;
      border-radius: 7px;
      display: inline-block;
      line-height: 35px;
      text-align: center;
      color: #718096;
      font-size: 14px;
      box-sizing: border-box;
      cursor: pointer;
    }
    .guanbi:active {
      background: rgba(245, 245, 245, 0.5);
    }
  }
}
</style>